import { AbilityClaimStatus } from './ability'

export const CLAIMS_REPORT_COLUMNS = [
  'payer',
  'patientName',
  'dateOfService',
  'claimStatus',
  'serviceType',
] as const

export type ClaimsReportColumn = (typeof CLAIMS_REPORT_COLUMNS)[number]

// Columns (and order) a new claims report starts with — currently every available column.
export const DEFAULT_CLAIMS_REPORT_COLUMNS: ClaimsReportColumn[] = [...CLAIMS_REPORT_COLUMNS]

export const CLAIMS_REPORT_COLUMN_LABELS: Record<ClaimsReportColumn, string> = {
  payer: 'Payer',
  patientName: 'Patient Name',
  dateOfService: 'Date of Service',
  claimStatus: 'Claim Status',
  serviceType: 'Service Type',
}

export const ALL_CLAIM_STATUSES: AbilityClaimStatus[] = [
  'ERROR',
  'PAID',
  'ACK_FINAL',
  'ACK_PENDING',
  'HOLD',
  'MODIFIED',
  'VALIDATED',
  'DENIED',
  'TRANSMIT',
  'RELEASED',
  'REJ_PAYER',
  'PROCESSING',
  'submitting',
]

export const CLAIM_STATUS_LABELS: Record<AbilityClaimStatus, string> = {
  ERROR: 'Error',
  PAID: 'Paid',
  ACK_FINAL: 'Acknowledged (Final)',
  ACK_PENDING: 'Acknowledged (Pending)',
  HOLD: 'Hold',
  MODIFIED: 'Modified',
  VALIDATED: 'Validated',
  DENIED: 'Denied',
  TRANSMIT: 'Transmitted',
  RELEASED: 'Released',
  REJ_PAYER: 'Rejected by Payer',
  PROCESSING: 'Processing',
  submitting: 'Submitting',
}

export interface ClaimsReport {
  practiceId: string
  statuses: AbilityClaimStatus[]
  columns: ClaimsReportColumn[]
  status: 'generating' | 'generated' | 'error_generating'
  storagePath?: string
  errorMessage?: string
  createdOn: number
  createdBy: string
}
